import { writable } from 'svelte/store';
import api from '../services/api.js';

// Store for application configuration
export const config = writable({
  authEnabled: true,
  appName: 'Moira Finance',
  loading: true,
  error: null
});

// Fetch configuration from backend
export async function loadConfig() {
  try {
    const data = await api.getConfig();
    config.set({
      authEnabled: data.auth_enabled,
      appName: data.app_name || 'Moira Finance',
      loading: false,
      error: null
    });
  } catch (error) {
    console.error('Failed to load config:', error);
    // Default to auth enabled if config fails to load
    config.set({
      authEnabled: true,
      appName: 'Moira Finance',
      loading: false,
      error: error.message
    });
  }
}